import { webRoutes } from "@/config/web/routes";
import { Navigate, useParams } from "react-router";

/** `/projects/:projectId` has no page of its own; project cards open capture. */
export const ProjectIndexRedirect = () => {
  const { projectId = "" } = useParams();
  return (
    <Navigate
      to={webRoutes.capture.replace(":projectId", projectId)}
      replace
    />
  );
};
